














































import { Component, Mixins } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";

// Types
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";
import CProdProvInjectorMixin from "@/mixins/cProdProvInjectorMixin";
import CProdSetupForm from "@/components/app/global/contractProducts/cProdProvConfigManageForm.vue";

@Component({
  components: {
    "cprod-setup-form": CProdSetupForm
  }
})
export default class AdminCProdSetupView extends Mixins(
  CProdInjectorMixin,
  CProdProvInjectorMixin
) {
  // Refs

  public declare $refs: {
    observer: InstanceType<typeof ValidationObserver>;
    cProdSetupForm: CProdSetupForm;
  };

  // Data

  public isEnabled = false;
  public isProcessing = false;

  // Life-cycle methods

  public created() {
    this.guardView();
  }

  // Methods

  public guardView() {
    if (!this.cProdData.isAwaitingSetup) this.routeToOverview();
  }

  public onSetupComplete() {
    this.routeToOverview();
    this.$store.dispatch("toast/show", {
      message: this.$t("_.setup_complete")
    });
  }

  public async validateBeforeSubmit() {
    this.$refs.cProdSetupForm.validateBeforeSubmit();
  }

  public async revertToInitialState() {
    this.$refs.cProdSetupForm.revertToInitialState();
  }
}
